import { useCallback } from 'react';
import { de } from '../../i18n/de';
import { en } from '../../i18n/en';

type Messages = Record<string, unknown>;

/** Löst `a.b.c` gegen ein verschachteltes Objekt auf und ersetzt `%{name}`. */
export function translateFrom(messages: Messages, key: string, opts?: Record<string, unknown>): string {
    const value = key.split('.').reduce<any>((acc, part) => (acc && typeof acc === 'object' ? acc[part] : undefined), messages);
    if (typeof value !== 'string') return key;
    return value.replace(/%\{(\w+)\}/g, (_, name) => String(opts?.[name] ?? ''));
}

export function storefrontLocale(): 'de' | 'en' {
    const lang = typeof navigator !== 'undefined' ? navigator.language || 'de' : 'de';
    return lang.toLowerCase().startsWith('en') ? 'en' : 'de';
}

/**
 * Übersetzung der öffentlichen Storefront (`storefront.public.*`). Die Seite läuft
 * außerhalb von React-Admin (kein i18nProvider) und wählt Deutsch (Standard) oder
 * Englisch nach Browsersprache.
 */
export function useStorefrontT() {
    const locale = storefrontLocale();
    const messages = (locale === 'en' ? en : de).storefront as Messages;
    const t = useCallback((key: string, opts?: Record<string, unknown>) => translateFrom(messages, `public.${key}`, opts), [messages]);
    return { t, locale };
}
